import { z } from 'zod';

/////////////////////////////////////////
// CORE NOTIFY SETTING VOICE DICTIONARY RULE SCHEMA
/////////////////////////////////////////

export const CoreNotifySettingVoiceDictionaryRuleSchema = z.object({
  id: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  notifySettingId: z.number().int().nullable(),
  find: z.string(),
  replace: z.string(),
})

export type CoreNotifySettingVoiceDictionaryRule = z.infer<typeof CoreNotifySettingVoiceDictionaryRuleSchema>

export default CoreNotifySettingVoiceDictionaryRuleSchema;
